import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, useToast } from '@chakra-ui/react';

import { useFormik } from "formik";

import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDropzone } from 'react-dropzone';
import trainerRegistration from '../../../services/trainer/trainerRegistration';
import { classOfDegree, degrees } from '../../../utils/classOfDegree';
import { Years } from '../../../utils/years';

export const EduQualificationModal: React.FC<any> = ({ isOpenEducationQualification, onCloseEducationQualification, isEducationQualification = false, reload }: { isOpenEducationQualification: any, onCloseEducationQualification: any, isEducationQualification: boolean, reload: any }) => {
  const [gender, setGender] = useState<any[]>([]);
  const [years, setYears] = useState<any[]>([]);
  const toast = useToast();
  const [cod, setClassofdegree] = useState<any[]>([]);
  const [degree, setDegree] = useState<any[]>([]);
  const [batchFile, setbatchFile] = useState<File | null>(null)
  const [filename, setFilename] = useState('')
  const [loading, isLoading] = useState(false)
  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' ,
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
  }

  const activeStyle = {
    borderColor: '#2196f3',
  }

  const acceptStyle = {
    borderColor: '#00e676',
  }

  const rejectStyle = {
    borderColor: '#ff1744',
  }
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: 'File Upload',
        description: 'Invalid file uploaded',
        status: 'error',
      })
      setbatchFile(null)
    } else {
      const formData = new FormData()
      const file = acceptedFiles[0]
      setFilename(file.name)
      
      formData.append('batchfile', file)
      setbatchFile(file)
      toast({
        title: 'File Upload',
        description: 'Your file is ready for upload',
        status: 'success',
      })
    }
  }, [])


  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({ onDrop })
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept],
  )



  useEffect(() => {
    setYears(Years());
    setClassofdegree(classOfDegree());
    setDegree(degrees());
    
    const maingender = [{
      id: '1',
      title: 'male'
    },
    {
      id: '2',
      title: 'female'
    }
    ]
    setGender(maingender)

  }, []);

  const cancelRef = useRef().current;
  const formik = useFormik({
    validate: (values: any) => {
      // const errors: any = {};
      // if (!values.firstName) {
      //   errors.firstName = 'First Name is required'
      // }
      // if (!values.lastName) {
      //   errors.lastName = 'Last Name is required'
      // }
      // if (!values.country) {
      //   errors.country = 'Country is required'
      // }
      // if (!values.role) {
      //   errors.role = 'Role is required'
      // }
      // if (!values.office) {
      //   errors.office = 'Office is required'
      // }
      // return errors;
    },
    initialValues: {
      courseDiscipline: "",
      institutionName: '',
      degree: '',
      programOfStudy: '',
      classOfDegree: '',
      yearObtained: '',
    },
    onSubmit: async (values) => {

      const formData = new FormData()
      if (batchFile) {
        const file = batchFile
        
        formData.append('doc', file, file.name)
        formData.append('institution', values.institutionName)
        formData.append('discipline',values.courseDiscipline)
        formData.append('program', values.programOfStudy)
        formData.append('class_of_degree',values.classOfDegree)
        formData.append('year',values.yearObtained)
        formData.append('degree', values.degree)
       
        try {
          const basicResponse = await trainerRegistration.updateUserEducation(formData);
          if (basicResponse) {

            
            toast({
              title: "Registration",
              description: "Education profile successful",
              status: "success",
            })
            onCloseEducationQualification()
            reload()
            formik.resetForm()
          }
        } catch (error) {

          toast({
            title: "Registration",
            description: "something went wrong",
            status: "error",
          })
        }

      }





      



    }
  })

  return (
    <>
      <Modal
        isOpen={isOpenEducationQualification && isEducationQualification}
        onClose={onCloseEducationQualification}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3}>
          <ModalHeader>
            <Text textAlign='center' mx='auto' color="#353535" fontSize="32px" fontWeight='800'>
              Education Qualification
            </Text>
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody>
            <Box mt={4}>

              <form onSubmit={formik.handleSubmit}>
                <FormControl mb='15px' isInvalid={(formik.errors.institutionName && formik.touched.institutionName) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}> Name of Institution</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter institution name" value={formik.values.institutionName} name="institutionName" onChange={formik.handleChange} fontSize={12} />
                  <FormErrorMessage fontSize={12} >{formik.errors.institutionName}</FormErrorMessage>
                </FormControl>
                <FormControl mb='15px' mt={6} isInvalid={(formik.errors.courseDiscipline && formik.touched.courseDiscipline) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}>Course / Discipline</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter course discipline" value={formik.values.courseDiscipline} name="courseDiscipline" onChange={formik.handleChange} fontSize={12} />
                  <FormErrorMessage fontSize={12} >{formik.errors.courseDiscipline}</FormErrorMessage>
                </FormControl>

                <FormControl mb='15px' mt={6} isInvalid={(formik.errors.programOfStudy && formik.touched.programOfStudy) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}>Program of Study</FormLabel>
                  <Input bg="inputText.500" placeholder="Enter program of study" value={formik.values.programOfStudy} name="programOfStudy" onChange={formik.handleChange} fontSize={12} />

                  <FormErrorMessage fontSize={12} >{formik.errors.classOfDegree}</FormErrorMessage>
                </FormControl>
                <FormControl mb='15px' mt={6} isInvalid={(formik.errors.degree && formik.touched.degree) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}>Degree</FormLabel>
                  <Select variant="outline" bg="inputText.500" size="md" placeholder="Select Degree" value={formik.values.degree} name="degree" onChange={formik.handleChange} fontSize={12} color="brand.subtitle" >
                    {
                      degree.map(degree => <option key={degree} value={degree}> {degree} </option>)
                    }
                  </Select>
                  <FormErrorMessage fontSize={12} >{formik.errors.degree}</FormErrorMessage>
                </FormControl>
                <FormControl mb='15px' mt={6} isInvalid={(formik.errors.classOfDegree && formik.touched.classOfDegree) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}>Class of Degree</FormLabel>
                  <Select variant="outline" bg="inputText.500" size="md" placeholder="Class of Degree" value={formik.values.classOfDegree} name="classOfDegree" onChange={formik.handleChange} fontSize={12} color="brand.subtitle" >
                    {
                      cod.map(degree => <option key={degree} value={degree}> {degree} </option>)
                    }
                  </Select>
                  <FormErrorMessage fontSize={12} >{formik.errors.classOfDegree}</FormErrorMessage>
                </FormControl>
                <FormControl mb='15px' mt={6} isInvalid={(formik.errors.yearObtained && formik.touched.yearObtained) ? true : false} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}>Year Obtained</FormLabel>
                  <Select variant="outline" bg="inputText.500" size="md" placeholder="Select Year" value={formik.values.yearObtained} name="yearObtained" onChange={formik.handleChange} fontSize={12} color="brand.subtitle" >
                    {
                      years.map((each, index) => (<option key={index} value={each}> {each} </option>)
                      )
                    }
                  </Select>
                  <FormErrorMessage fontSize={12} >{formik.errors.yearObtained}</FormErrorMessage>
                </FormControl>
                <FormControl mb='15px' mt={6} >
                  <FormLabel fontWeight="700" color="#616161" fontSize={13}>Upload Certificate</FormLabel>
                  <Text fontWeight="400" color="#959595" fontSize='14px'>Upload an image of the certificate. (Not larger than 2MB)</Text>

                  <div {...getRootProps({ style })}>
                    <input {...getInputProps()} />
                    {
                      isDragActive ?
                        <p>Drop the files here ...</p> :
                        <p>Click here or drag and drop your file </p>
                    }
                  </div>
                  {filename && (
                    <Text fontWeight="400" color="#959595" fontSize='12px'>{filename}</Text>
                  )}
                </FormControl>




                <Flex justifyContent="flex-end" mt={6}>
                  <HStack>
                    <Button py='13px' px='30px'   mt='20px' type="submit" fontSize={11} isLoading={formik.isSubmitting} borderRadius={0} colorScheme='red' size='sm'>
                      SAVE
                    </Button>
                  </HStack>
                </Flex>

              </form>

            </Box>


          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

